import { WEBSOCKET, type WebSocketService } from "@packages/common";
import { Inject, Injectable } from "@webmotors/ioc";
import type { User } from "../user";
import { CHAT_SERVICE } from "./chat.types";
import type { ChatDTO } from "./dtos";

@Injectable(CHAT_SERVICE)
export class ChatService {
  constructor(
    @Inject(WEBSOCKET) private readonly websocketService: WebSocketService
  ) {}

  public async getChats(user: User): Promise<ChatDTO> {
    const totalUnreadChats = { to: undefined, from: undefined };
    let isResolved = false;

    return new Promise<ChatDTO>((resolve, reject) => {
      this.websocketService.connect(`?token=${user.authenticationToken}`);

      this.websocketService.on("open", () => {
        const messageTo = { chatType: "to", limit: 50 };
        this.websocketService.send("getChats", messageTo);

        const messageFrom = { chatType: "from", limit: 50 };
        this.websocketService.send("getChats", messageFrom);
      });

      this.websocketService.on("getChats", (payload: any) => {
        if (payload.chatType === "to") {
          totalUnreadChats.to = payload.unreadChats ?? 0;
        } else if (payload.chatType === "from") {
          totalUnreadChats.from = payload.unreadChats ?? 0;
        }

        if (
          !isResolved &&
          totalUnreadChats.to !== undefined &&
          totalUnreadChats.from !== undefined
        ) {
          isResolved = true;
          const unreadChats = totalUnreadChats.to + totalUnreadChats.from;
          this.websocketService.close();
          resolve({ unreadChats });
        }
      });

      this.websocketService.on("error", (error: Error) => {
        if (!isResolved) {
          isResolved = true;
          this.websocketService.close();
          reject(error);
        }
      });

      this.websocketService.on("close", () => {
        if (!isResolved) {
          isResolved = true;
          reject(new Error("WebSocket closed unexpectedly"));
        }
      });
    });
  }
}
